<div *ngIf="canEdit || !aboutMeSection.empty" class="bulb-about-me-section">
<div class="drag-line" pDroppable="section" (onDrop)="drop($event, aboutMeSection)"></div>
  <span [ngClass]="{'show-handle': !editMode && canEdit}" pDraggable="section" (onDragStart)="dragStart($event, aboutMeSection)" class="resume-drag-handle">
    <svg-icon
      [key]="'grip-lines-solid'"
      fontSize="1.5rem"
  >
  </svg-icon>
  </span>
  <bulb-resume-section sectionName="{{ 'resume.aboutMe.label' | transloco }}"
             [resumeSection]="aboutMeSection"
             [resumeComponent]="resumeComponent"
             [showEditIcon]="!editMode && canEdit"
             [showDeleteIcon]="canEdit && !editMode"
             [canEdit]="canEdit"
             [(open)]="isTabOpen"
             (onEdit)="beginEdit()"
             class="about-me"
             (onClose)="handleTabClose($event)"
             (onOpen)="handleTabOpen($event)"
             pDraggable="section"
             pDroppable="section"
             (onDrop)="drop($event, aboutMeSection)"
             (onDragStart)="dragStart($event, aboutMeSection)"
             [pDraggableDisabled]="isTabOpen">
    <div sectionContent>
      <bulb-resume-sub-section [allowSubSectionDelete]="false"
                   [editMode]="editMode"
                   [resumeComponent]="resumeComponent"
                   [resumeSection]="aboutMeSection"
                   [isOnlyPortfolioContent]="isOnlyPortfolioContent"
                   [units]="portfolioContent">

        <aero-form subSectionEdit
               submitButtonLabel="{{ 'saveButton' | transloco }}"
               [showCancelButton]="true"
               (onCancel)="cancelEdit()"
               (onSubmit)="save($event)">
          <div class="bulb-centered-content">
            <div class="bulb-about-me-textarea-container">
              <label transloco="resume.aboutMe.description"
>Share information about yourself</label>
              <span aeroTooltipPosition="top"
                  aeroTooltip="{{ 'resume.about.yourself' | transloco }}"
                  aeroTooltip=
  "Tell us who you are as a professional or a person. Highlight your skills and greatest strengths. Let others know your career goals.">
                  <i class="fal fa-info-circle"></i>
              </span>
              <bulb-editor *ngIf="editMode"
                name="description"
                id="description"
                [editable]="true"
                [initData]="aboutMeSubSectionClone.description"
                (dataChange)="updateAboutMeData($event)"
                [maxLength]="maxLength"
                (limitReached)="handleLimitReached($event)"
                [autofocus]="true">
              </bulb-editor>
            </div>

            <div class="text-center bulb-resume-add-btn ">
              <aero-button
			  	[aeroStyle]="buttonStyle"
                icon="fal fa-plus"
                label="{{ 'resume.add.portfolioContent' | transloco }}"
                (onClick)="addPortfolioContent()">
              </aero-button>
            </div>
            <!-- Show the selected portfolio content : -->
            <bulb-resume-content-selection-display
              [aeroFormComponent]="aeroFormComponent"
              [resumeSubSection]="this"
              [editMode]="editMode"
              [renderResumeSubSectionTileView]="true"
              [units]="portfolioContent"
              (onUnitRemoved)="onPortfolioContentRemoval($event)">
            </bulb-resume-content-selection-display>
          </div>
        </aero-form>
        <div subSectionView>
          <p [innerHTML]="aboutMeSubSectionClone.description" class="about-me-description"></p>
        </div>
      </bulb-resume-sub-section>
    </div>
  </bulb-resume-section>
</div>
